/**
 * Redirects for legacy routes whose pages have been replaced by a successor
 * tool. Preserves the project prefix, hash and query — none of which Nitro
 * routeRules redirects can carry for project-scoped paths.
 *
 * Global (not page middleware) so it runs BEFORE project-id.global — otherwise
 * anonymous visitors following marketing links to a legacy path would be sent
 * to /login instead of the public successor page.
 */
import { resolveLegacyRedirect } from '../utils/legacy-redirects'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return
  }

  const redirect = resolveLegacyRedirect(to.path, to.fullPath)
  if (redirect) {
    // Full reload: legacy routes no longer exist, so a hard visit boots on a 404
    // route with no params — boot-time behavior tied to the URL (project selection
    // from /project/:id) only works when the app boots on the live target route.
    return navigateTo(redirect, { external: true, replace: true })
  }
})
